@use "~theme/typography";

.label {
  @include typography.field-label;
  margin-bottom: 8px;
}

.valueContainer {
  display: flex;
  align-items: baseline;
}

.icon {
  position: relative;
  top: 2px;
  margin-right: 8px;
  max-width: 16px;
}

.value {
  @include typography.body;
}
